var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('checkbox-group',{staticClass:"kpis-legend",attrs:{"options":_vm.items,"value":_vm.value,"alwaysFilled":"","multiSelect":_vm.multiSelect,"vertical":_vm.vertical},on:{"input":_vm.onKpiChange}})}
var staticRenderFns = []

export { render, staticRenderFns }